import { BillingMetrics } from '../../../shared/BillingMetrics';

interface MetricData {
  metricId: string;
  quantity: number;
  allowAdditionalItem: boolean;
  additionalItemValue: number;
}

interface ItemData {
  metric: MetricData;
  total: number;
  exceededPlan: number;
  planUsage: number;
}

export class AiTokenUsageTotal {
  aiTokenTotal!: number;

  constructor(raw: { items: ItemData[] }) {
    this.aiTokenTotal = raw.items.find((item) => item.metric.metricId === BillingMetrics.aiToken)?.total ?? 0;
  }
}
